import { useNombreConversationsNonLues } from '../api/useNombreConversationsNonLues';
import { useNombreSupportATraiter } from '../api/useSupportMobile';

/**
 * Le chiffre de l'icône de l'app : conversations non lues de la messagerie, plus,
 * pour l'équipe TriggerFlow seulement, ce qu'il reste à traiter au support.
 * Le support compte 0 (et ne s'interroge pas) pour tout autre compte.
 */
export function useNombreBadgeApp(): number {
    return useNombreConversationsNonLues() + useNombreSupportATraiter();
}
